// @ts-check
import { graphql } from 'gatsby';
import React from 'react';
import { useContentStackProps } from '~/contentstack';
import SvgImage from './images/SvgImage';

import './Accolades.scss';

export const Accolades_REFERENCES = ['accolades.list'];

export const query = graphql`
	fragment AccoladesFragment on Ozk_pageContent {
		accolades {
			heading
			list {
				uid
				accolade {
					copy
					icon {
						...AssetFragment
					}
				}
			}
			heading
		}
	}
`;

/**
 * @typedef SingleAccolade
 * @property {string[]} copy
 * @property {import('../CSTypes').CSFile} icon
 *
 * @typedef AccoladeList
 * @property {string} uid
 * @property {SingleAccolade[]} accolade
 *
 * @typedef AccoladesProps
 * @property {AccoladeList[]} list
 * @property {string} heading
 */
/** @type {React.FC<{ options: AccoladesProps }>} */
const Accolades = ({ options }) => {
	const [model] = useContentStackProps({
		staticModel: options?.list?.[0],
		contentType: 'accolade_list',
		contentUid: options?.list?.[0].uid,
	});

	return (
		<div className="accolades">
			<h2 className="title">{options.heading}</h2>

			<ul className="accolade-container container">
				{model.accolade?.map((acc, i) => (
					<li key={i} className="an-accolade">
						<div className="an-accolade-logo">
							<SvgImage options={{ alt_text: acc.icon.title, svg: acc.icon }} />
						</div>
						<ul className="sub-texts">
							{acc.copy.map((st, j) => (
								<li className="sub-text" key={j}>
									{st}
								</li>
							))}
						</ul>
					</li>
				))}
			</ul>
		</div>
	);
};

export default Accolades;
